import * as classNames from "classnames";
import * as React from "react";
import * as myClasses from "../../../components";

import { IProps, TabId } from "@blueprintjs/core";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertListActions, globalActions } from "../../../actions";

import { LeftPanelContainer } from 'src/components';

import "./styles.css";

import {
  Classes,
  IMPDTreeNode,
} from "src/mpd-library/";

import {
  AlertsDraftListItem,
  AlertsListItem,
  AlertsScheduledListItem,
  ListEmpty,
  ListSearch,
  ListSearchBar,
  ListTabs,
  ListTree
} from "../components";

import "./styles.css";

interface IListProps extends IProps {
  list: Array<any>;
  listItemType: React.ComponentClass<any> | React.StatelessComponent<any>;
  rightPanelExpanded?: boolean;
  loading?: boolean;
  searchBarActive?: boolean;
  searchBarText: string;
  searchFound?: boolean;
  mobileSideBarActive?: boolean;
  tabNum: TabId;
  routeProps: any;
  onHandleNodeCollapse: (
    nodeData: IMPDTreeNode
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onHandleNodeExpand: (
    nodeData: IMPDTreeNode
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onRowClicked: (
    nodeData: IMPDTreeNode,
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onSearchChanged: (
    value: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onToggleSearchBar: () => (dispatch: Dispatch<any>) => Promise<void>;
  onShowCompose: (history: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onToggleMobileSideBar: () => (dispatch: Dispatch<any>) => Promise<void>;
  onChangedTabs: (
    tabId: string,
    listItemType: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
}

interface IListState {
  init: boolean;
  tabs: Array<string>;
  tabNum: TabId;
  nodeData?: IMPDTreeNode;
  getNodeId?: string;
  adjustedList: boolean;
}

export class List extends React.Component<IListProps, IListState> {

  constructor(props: IListProps) {
    super(props);
    this.onChangedTabs = this.onChangedTabs.bind(this);
    this.onRowClicked = this.onRowClicked.bind(this);
    this.onHandleNodeCollapse = this.onHandleNodeCollapse.bind(this);
    this.onHandleNodeExpand = this.onHandleNodeExpand.bind(this);
    this.onSearchChanged = this.onSearchChanged.bind(this);
    this.onShowCompose = this.onShowCompose.bind(this);
    this.onToggleSearchBar = this.onToggleSearchBar.bind(this);
    this.onToggleMobileSideBar = this.onToggleMobileSideBar.bind(this);

    const tabs: Array<string> = [
      "ACTIVE",
      "EXPIRED",
      "CANCELLED",
      "DRAFTS",
      "SCHEDULED"
    ];

    const pathnameArr = this.props.routeProps.history.location.pathname.split(
      "/"
    );

    const { tabNum } = this.props;

    this.state = {
      adjustedList: false,
      tabs,
      tabNum,
      init: true,
      getNodeId: pathnameArr[pathnameArr.length - 1]
    };

    this.props.onChangedTabs("active", AlertsListItem);
  }

  public render() {
    const {
      className,
      searchBarActive,
      mobileSideBarActive,
      list,
      loading,
      listItemType,
      searchBarText,
      rightPanelExpanded
    } = this.props;

    const { tabs, tabNum, adjustedList } = this.state;

    return (
      <LeftPanelContainer
        className={classNames(
          myClasses.LIST_CONTAINER,
          (list === null || (list && list.length === 0)) && Classes.EMPTY,
          adjustedList && 'test',
          className
        )}
        mobileSideBarActive={mobileSideBarActive}
        overlayVisible={mobileSideBarActive}
        onOverlayClick={this.onToggleMobileSideBar}
        collapsed={rightPanelExpanded}
      >
        <ListSearchBar
          className={classNames(
            mobileSideBarActive && "sidebar-" + Classes.ACTIVE,
            searchBarActive && "search-" + Classes.ACTIVE
          )}
          onSearchChange={this.onSearchChanged}
          onToggleSearchBar={this.onToggleSearchBar}
          onRightButtonClick={this.onShowCompose}
          onLeftButtonClick={this.onToggleMobileSideBar}
          searchBarText={searchBarText}
        />
        <div
          className={classNames(
            myClasses.LIST_INNER_CONTAINER,
            searchBarText.length > 0 && "search-" + Classes.ACTIVE
          )}
        >
          <ListTabs
            className={classNames(
              searchBarText.length > 0 && "search-" + Classes.ACTIVE
            )}
            tabNum={tabNum}
            tabs={tabs}
            onChangeTabs={this.onChangedTabs}
            panel={
              list && list.length > 0 ? (
                <ListTree
                  NodeItem={listItemType}
                  contents={list}
                  loading={loading}
                  onNodeClick={this.onRowClicked}
                  onNodeCollapse={this.onHandleNodeCollapse}
                  onNodeExpand={this.onHandleNodeExpand}
                />
              ) : (
                <ListEmpty
                  iconName='list-view--no-content-icon'
                  title="no active alerts"
                  subtitle="Tap on the blue lightening bolt icon to create a new alert."
                />
              )
            }
          />
          {searchBarText.length > 0 && (
            <ListSearch
              onNodeClick={this.onRowClicked}
              onNodeCollapse={this.onHandleNodeCollapse}
              onNodeExpand={this.onHandleNodeExpand}
              NodeItem={listItemType}
              list={list}
              loading={loading}
              searchBarText={searchBarText}
            />
          )}
        </div>
      </LeftPanelContainer>
    );
  }

  // private onInit() {
  //   this.setState({ init: false }, () => {
  //     const { routeProps } = this.props;
  //     const { nodeData } = this.state;
  //     const pathname = routeProps.history.location.pathname;
  //     const pathnameArr = pathname.split("/");
  //     const barTitle = (nodeData as any).listData.title;
  //     let topBarProps: IToolBarProps = this.getDefaultTopBarProps(barTitle);
  //     let tabId = "active";

  //     if (nodeData) {
  //       tabId = pathnameArr[pathnameArr.length - 2];
  //       this.setState({ tabNum: 3 });
  //       this.props.onChangedTabs(tabId, AlertsDraftListItem);
  //     } else {
  //       topBarProps = this.getDefaultTopBarProps("compose");
  //     }

  //     this.props.onInitializeList(tabId, topBarProps, routeProps, nodeData);
  //   });
  // }

  // private onGetNode(nodeData: any) {
  //   // const { init } = this.state;
  //   // this.setState({ nodeData }, () => {
  //   //   if (init) {
  //   //     this.onInit();
  //   //   }
  //   // });
  // }

  private onHandleNodeCollapse(nodeData: IMPDTreeNode) {
    this.props.onHandleNodeCollapse(nodeData);
  }

  private onHandleNodeExpand(nodeData: IMPDTreeNode) {
    this.props.onHandleNodeExpand(nodeData);
  }

  private onChangedTabs(newTabNum: TabId, prevTabNum: TabId, event: any) {
    this.setState({ tabNum: newTabNum });
    const { tabs } = this.state;
    const tabId: string = tabs[newTabNum].toLowerCase();
    if (newTabNum === 3) {
      this.props.onChangedTabs(tabId, AlertsDraftListItem);
    } else if (newTabNum === 4) {
      this.props.onChangedTabs(tabId, AlertsScheduledListItem);
    } else {
      this.props.onChangedTabs(tabId, AlertsListItem);
    }
  }

  private onRowClicked(
    nodeData: IMPDTreeNode,
    nodePath: Array<number>,
    e: React.MouseEvent<HTMLElement>
  ) {
    const { routeProps } = this.props;
    const { history } = routeProps;
    this.props.onRowClicked(nodeData, history);
  }

  private onToggleMobileSideBar() {
    this.props.onToggleMobileSideBar();
  }

  private onShowCompose(event?: React.MouseEvent<HTMLElement>) {
    const { routeProps, onShowCompose } = this.props;
    onShowCompose(routeProps.history);
  }

  private onSearchChanged(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.onSearchChanged(event.target.value);
  }

  private onToggleSearchBar(event: React.MouseEvent<any>) {
    this.props.onToggleSearchBar();
  }
}

const mapStateToProps = (state: any) => {
  const { alerts, global } = state;

  const {
    listItemType,
    rightPanelExpanded,
    loading,
    list,
    searchBarActive,
    searchFound,
    searchBarText,
    tabNum
  } = alerts;

  const { mobileSideBarActive } = global;

  return {
    list,
    listItemType,
    rightPanelExpanded,
    loading,
    mobileSideBarActive,
    searchBarActive,
    searchFound,
    searchBarText,
    tabNum
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onRowClicked: bindActionCreators(alertListActions.onRowClicked, dispatch),
    onSearchChanged: bindActionCreators(
      alertListActions.onSearchChanged,
      dispatch
    ),
    onShowCompose: bindActionCreators(alertListActions.onShowCompose, dispatch),
    onToggleMobileSideBar: bindActionCreators(
      globalActions.onToggleMobileSideBar,
      dispatch
    ),
    onHandleNodeCollapse: bindActionCreators(
      alertListActions.onHandleCollapse,
      dispatch
    ),
    onHandleNodeExpand: bindActionCreators(
      alertListActions.onHandleExpand,
      dispatch
    ),
    onToggleSearchBar: bindActionCreators(
      alertListActions.onToggleSearchBar,
      dispatch
    ),
    onChangedTabs: bindActionCreators(alertListActions.onChangedTabs, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);



// WEBPACK FOOTER //
// ./src/controllers/alerts/list/list.tsx